import { useJobDetails } from "@/context/JobDetailsContext";

const SwitchTab = ({
	handleTabChange,
	activeTab,
	file
}: {
	handleTabChange: (tab: "addJD" | "assessmentConfig") => void;
	activeTab: string;
	file: any
}) => {
	const { jobDetails } = useJobDetails()
	return (
		<div>
			{/* Tabs */}

			<div className="flex font-body md:text-base text-sm">
				<button
					onClick={() => handleTabChange("addJD")}
					className={`px-4 py-2 border-b-2 ${activeTab === "addJD"
						? " border-[#438437] text-[#438437]"
						: "text-[#7F7F7F]"
						}`}
				>
					Create New Job
				</button>
				<button
					onClick={() => handleTabChange("assessmentConfig")}
					className={`px-4 py-2 border-b-2 ${activeTab === "assessmentConfig"
						? "border-[#438437] text-[#438437]"
						: "text-[#7F7F7F]"
						} ${!jobDetails?.title || (!file && !jobDetails?.description)
							? "cursor-not-allowed"
							: ""
						}`}
					disabled={!jobDetails?.title || (!file && !jobDetails?.description)}
				>
					Assessment Configuration
				</button>
			</div>
		</div >
	);
};

export default SwitchTab;
